import {
	REMOVE_USER,
	RESET_AUTH_DATA,
	SIGN_IN_USER,
	SIGN_UP_USER,
} from '../constants/ActionTypes';
import { AuthTypes } from '../constants/Types';

export const signUpUser = (
	data: {
		userName: string;
		email: string;
		token: null | undefined | string;
	},
	success?: (userName: string) => void,
	failed?: (error: string) => void
) => ({
	type: SIGN_UP_USER,
	payload: { ...data },
	success,
	failed,
});

export const signInUser = (
	data: {
		authType: AuthTypes;
		userName?: string | null;
		name?: string | null;
		email?: string | null;
		profilePicture?: string | null;
	},
	success?: (userName: string) => void,
	failed?: () => void
) => ({
	type: SIGN_IN_USER,
	payload: { ...data },
	success,
	failed,
});

export const deleteUser = (
	data,
	success?: () => void,
	failed?: () => void
) => ({
	type: REMOVE_USER,
	payload: data,
	success,
	failed,
});

export const resetAuthData = (success?: () => void, failed?: () => void) => ({
	type: RESET_AUTH_DATA,
	success,
	failed,
});
